<template>
  <div id="search">
    <b-container fluid>
      <h4>Last Updated: {{lastUpdated}}</h4>
      <p></p>
      <p>This data is provided to you by the CHIME/FRB collaboration. If you use this data, please use the following acknowledgement: <br> <b style="color:green">We acknowledge use of the CHIME/FRB Public Database, provided at https://www.chime-frb.ca/ by the CHIME/FRB Collaboration.</b></p>
      <p>
        Note that is page is manually updated by a human and so can have a significant delay. 
        Repeat bursts are also sent automatically by our VOEvent stream as “subsequent” events. See here: <a href="https://www.chime-frb.ca/voevents" target="_blank" rel="noopener noreferrer">CHIME/FRB VOEvents Overview Page</a>.
      </p>
      <h2>Repeating FRBs (Total: {{filteredItems.length}} sources)</h2>
      <p style="color: red;">Repeaters that have a burst in the past 10 days are highlighted in red</p>
      <!--<h2 v-else>Coming soon ... Please stay tuned :) </h2>-->
      <b-row>
        <!--<b-col xl="3" md="4">
          <b-row style="margin-left: 5px;" >
            <b-button @click="addFilter" variant="primary" style="margin-bottom: 20px;">
              {{ $t('latestAddFilter') }}
            </b-button>
            <font-awesome-icon style="margin-left: 5px; margin-top: 3px;"
                              :icon="['fas', 'question-circle']"
                              size="2x"
                              v-b-popover.hover="$t('latestFilterDesc')"
            />
          </b-row>
          <div style="margin-left: 20px;" v-for="filter in filters" v-bind:key="filter['id']" >
            <b-form inline style="margin-bottom: 20px;">
              <b-row>
                <b-button pill
                          variant="danger"
                          style="margin-right: 10px; margin-bottom: 10px;"
                          @click="deleteFilter(filter['id']); removeSearchParameters(filter['value'])"
                >
                  {{ $t('latestDelete')}}
                </b-button>
                <b-form-select v-model="filter['value']"
                               style="margin-right: 15px;"
                               :options="options"
                               @change="onFilterChange(filter)"
                />
                <div v-if="filter['value'] == 'id'">
                  <b-form-input v-model="search_parameters['id']"
                                style="margin-top: 15px;"
                                placeholder="Please enter event ID"
                                type="number"
                  />
                </div>
                <div v-else-if="filter['value'] == 'date'" >
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters['date_min']" style="margin-top: 15px;" type="date"/>
                  </b-row>
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters['date_max']"  type="date"/>
                  </b-row>
                </div>
                <div v-else-if="filter['value'] != 'null' && filter['value']">
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters[filter['value'] + '_min']"
                                  style="margin-top: 15px; "
                                  placeholder="Enter minimum value"
                                  type="number"
                    />
                  </b-row>
                  <b-row style="margin-left: 0px;">
                    <b-form-input v-model="search_parameters[filter['value'] + '_max']"
                                  placeholder="Enter maximum value"
                                  type="number"
                    />
                  </b-row>
                </div>
              </b-row>
            </b-form>
          </div>
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="danger"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            {{$t('latestOneFilter')}}
          </b-alert>
          <b-row style="margin-left: 5px;">
            <b-button variant="primary"
                      @click="filterItems"
                      v-if="showSubmit"
                      style="margin-bottom: 20px;"
            >
              {{ $t('latestSubmit') }}
            </b-button>
            <b-alert v-model="noResultsFound" variant="light">{{ $t('latestNoResult') }}</b-alert>
          </b-row>
        </b-col>-->
        <b-col xl="12" md="8" sm="7">
          <b-row>
            <b-col md="2" class="my-1">
              <b-form inline>
                <label class="mr-sm-2"> Per page </label>
              <!--<b-form-group horizontal label="Per page" class="mb-0">-->
                <b-form-select :options="pageOptions" v-model="perPage" />
              <!--</b-form-group>-->
              </b-form>
            </b-col>
            <b-col md="2" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              />
            </b-col>
            <b-col md="4" class="my-1">
               <a class="download-button"
                :href="downloadData"
                :download="'repeaters.json'">
                <b-button variant="dark"> 
                  Download Repeaters
                </b-button> 
              </a>
            </b-col>
            <b-col md="4" class="my-1">
              <div style="float:right">
              <b-form inline>
                <label class="mr-sm-2">Filter:</label>
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                    <b-input-group-append>
                      <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                    </b-input-group-append>
                  </b-input-group>
              </b-form>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" v-if="items.length != 0">
              <b-table  striped bordered outlined small responsive
                  v-if="items.length != 0"
                  :stacked="md"
                  :fields="repeaterFields"
                  :items="filteredItems"
                  :current-page="currentPage" 
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  @filtered="onFiltered"
              >
              <!--<template slot="source" slot-scope="row">{{row.value.first}} {{row.value.last}}</template>
              <template slot="isActive" slot-scope="row">{{row.value?'Yes :)':'No :('}}</template>
              <template slot="row-details" slot-scope="row">
                <b-card>
                  <ul>
                    <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
                  </ul>
                </b-card>
              </template>-->
              <template v-slot:head(dm)="data">
                {{ data.label }} (pc cm<sup>-3</sup>)
              </template>
              <template v-slot:cell(source_id)="data">
                <b-link v-bind:href="'/repeaters/' + data.item.source_id"> {{ data.item.source_id }} </b-link>
              </template>
              <template v-slot:cell(dm)="data">
                {{ data.item.dm }}
                <span v-if="checkIfDisplay(data.item.dm_error.error_high)">({{ data.item.dm_error.error_high }})</span>
              </template>
              <template v-slot:cell(publication)="data">
                <b-link v-bind:href="data.item.publication" target='_blank'> {{ data.item.arxiv_number }} </b-link>
              </template>
              <template v-slot:cell(localized)="data">
                <b-link v-bind:href="data.item.localized_link" target='_blank'> {{ data.item.localized }} </b-link>
              </template>
              </b-table>
            </b-col>
            <b-col md="12" v-else>
              <p>Loading...</p>
              <b-spinner
                v-for="variant in variants"
                :variant="variant"
                :key="variant"
                type="grow"
              ></b-spinner>
            </b-col>
          </b-row>         
        </b-col>
      </b-row>
      <b-table striped bordered outlined small
               v-if="eventsItems.length != 0"
               :fields="eventsFields"
               :items="eventsItems"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               style="margin-top: 50px"
      >
      <template v-slot:cell(source_id)="data">
        <b-link v-bind:href="'/repeaters/' + data.item.source_id" target="_blank"> {{ data.item.source_id }} </b-link>
      </template>
      <template v-slot:cell(dm)="data">
        {{ data.item.dm }}
        <span v-if="checkIfDisplay(data.item.dm)">( {{ data.item.dm_error.error_high }} )</span>
      </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
import {filterMixin} from './mixins/filter_mixin.js'
export default {
  name: "search",
  mixins: [filterMixin],
  data() {
    return {
      repeaterFields: [
        {key: 'source_id', label: 'ID', sortable: true},
        {key: 'previous_name', label: 'Previous Name', sortable: true},
        {key: 'last_burst_date', label: 'Latest Event', sortable: true},
        {key: 'dm', label: 'DM', sortable: true},
        {key: 'ra', label: 'RA', sortable: true},
        {key: 'dec', label: 'Dec', sortable: true},
        {key: 'nbEvents', label: 'Events', sortable: true},
        {key: 'publication', label: 'Arxiv Link', sortable: false},
        {key: 'localized', label: 'Host', sortable: true},
      ],
      options: [
        { value: null, text: this.$t('latestSelect')},
        { value: 'id', text: 'ID'},
        { value: 'dm', text: 'DM'},
        { value: 'date', text: 'Date'},
        { value: 'ra', text: 'RA'},
        {value: 'dec', text: 'Dec'},
        { value: 'snr', text: 'SNR'}
      ],
      eventsFields: [
        {key: 'source_id', label: 'ID', sortable: true},
        {key: 'dm', label: 'DM', sortable: true},
        {key: 'ra', label: 'RA', sortable: true},
        {key: 'dec', label: 'Dec', sortable: true},
        {key: 'time', label: this.$t('latestTime')},
        {key: 'publication', label: 'Arxiv link', sortable: false},
        {key: 'last_burst_date', label: 'Last Event', sortable: true},
        {key: 'localized', label: 'Host', sortable: true},
      ],
      sortBy: 'last_burst_date',
      eventsItems: [],
      whichEvents: "Repeaters",
    }
  },
  mounted() {
    this.generateItems()
  },
  methods: {
    generateItems () {
      // Generate a master list of Repeater objects
      this.noResultsFound = false
      var url = 'https://catalog.chime-frb.ca/repeaters'
      // var url = 'http://localhost:8081/repeaters'
      // Fetch all repeaters
      return this.$http.post(url, {'user_email': localStorage.user_email}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseResponse(response.body)
        })
    },
    parseResponse (sources) {
      // Parse data for all bursts and generate an FRB master list
      this.downloadItems = sources
      var sourceNames = Object.keys(sources)
      this.totalRows = sourceNames.length
      for (var i = 0; i < sourceNames.length; i++) {
        var item = {}
        var bursts = Object.keys(sources[sourceNames[i]])
        var baseFrbParams = ['ra', 'dec', 'publication', 'localized', 'last_burst_date', 'gl', 'gb', 'ne2001', 'ymw16', 'dm', 'previous_name']
        var counter = 0
        var last_burst = '0'
        var mean_dm = 0
        var num_good_bursts = 0
        var mean_dm_error = 0
        for (var j = 0; j < bursts.length; j++) {
          if (baseFrbParams.includes(bursts[j])) {
            continue
          }
          var burst = bursts[j]
          if (burst >= last_burst) {
            last_burst = burst
          }
          if (['string', 'number'].includes(typeof sources[sourceNames[i]][burst]['dm'].value) && sources[sourceNames[i]][burst]['dm'].value !== '') {
            mean_dm += parseFloat(sources[sourceNames[i]][burst]['dm'].value)
            mean_dm_error += parseFloat(sources[sourceNames[i]][burst]['dm'].error_high)
            num_good_bursts +=1

          } 
          item['eventIDs'] = bursts[j]
          counter += 1
        }
        item['source_id'] = sourceNames[i]
        item['previous_name'] = ''
        if (sources[sourceNames[i]]['previous_name']) {
          item['previous_name'] = sources[sourceNames[i]]['previous_name'].value
        }
        item['burst_id'] = burst
        item['dm'] = (mean_dm / num_good_bursts).toFixed(1)
        item['dm_error'] = {'error_high' : (mean_dm_error / num_good_bursts).toFixed(1)}
        item['snr'] = sources[sourceNames[i]][burst]['snr'].value
        item['ra'] = ''
        if (sources[sourceNames[i]]['ra']) {
          item['ra'] = sources[sourceNames[i]]['ra'].value
        }
        item['dec'] = ''
        if (sources[sourceNames[i]]['dec']) {
          item['dec'] = sources[sourceNames[i]]['dec'].value
        }
        item['localized'] = ''
        if (sources[sourceNames[i]]['localized']) {
          item['localized'] = sources[sourceNames[i]]['localized'].value
        }
        item['publication'] = ''
        if (sources[sourceNames[i]]['publication']) {
          item['publication'] = sources[sourceNames[i]]['publication'].value
        }
        item['arxiv_number'] = ''
        if (item['publication'] !== ''){
          item['arxiv_number'] = (item['publication'].split('/pdf/')[1]).split('.pdf')[0]
        }
        item['last_burst_date'] = sources[sourceNames[i]][last_burst]['timestamp'].value
        item['nbEvents'] = counter
        var date = item['last_burst_date'].split(' ')[0]
        date = Date.parse(date)
        var now_minus_10 = new Date()
        now_minus_10.setDate(now_minus_10.getDate()-10) // last 10 days
        if (date >= now_minus_10) {
          item['_rowVariant'] = 'danger'
        } else {
          item['_rowVariant'] = ''
        }
        this.items.push(item)
      }
      this.filterItems()
      this.whichEvents = "Repeaters"
    },
    filterItems () {
      // Filters the master list and generates a list of filtered items
      this.whichEvents = "Filtered"
      this.noResultsFound = false
      this.filteredItems = []
      // Loop through the master list, check if each item is to be added based on the first burst parameters,
      // parse added items a bit
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i]
        if (this.isToBeAdded(item) || (Object.entries(this.search_parameters).length === 0 &&
            this.search_parameters.constructor === Object)) {
          var filteredItem = {
            dm: (['string', 'number'].includes(typeof item['dm'])) ? item['dm']: "",//.toFixed(2),
            snr: (['string', 'number'].includes(typeof item['snr'])) ? item['snr']: "",//.toFixed(2),
            previous_name: (['string', 'number'].includes(typeof item['previous_name'])) ? item['previous_name']: "",
            ra: (['string', 'number'].includes(typeof item['ra'])) ? item['ra']: "",// .toFixed(2),
            dec: (['string', 'number'].includes(typeof item['dec'])) ? item['dec']: "",// .toFixed(2),
            source_id: item['source_id'],
            dm_error: (['string', 'number'].includes(typeof item['dm_error'].error_high)) ? item['dm_error']: "", // (Object.keys(item['dm_error']).includes['error_high']) ? item['dm_error']: {'error_high': ''},
            burstIDs: item['eventIDs'],
            nbEvents: item['nbEvents'],
            publication: item['publication'],
            arxiv_number: item['arxiv_number'],
            localized: (item['localized'] != 0) ? item['localized'].split(' ')[0]: '',
            localized_link: (item['localized'] != 0) ? item['localized'].split(' (')[1].split(')')[0]: null,
            last_burst_date: (typeof item['last_burst_date'] === 'string') ? item['last_burst_date']: "",
            _rowVariant: item['_rowVariant']
          }
          this.filteredItems.push(filteredItem)
        }
      }
      this.totalRows = this.filteredItems.length
      if (this.filteredItems.length == 0){
        this.noResultsFound = true
      }
    },
  }
}
</script>
<style>
.supsub {position: absolute}
.subscript {display:block; position:relative; left:2px; bottom: -18px}
.superscript {display:block; position:relative; left:2px; top: 2px}
.download-button {
    display: flex;
    justify-content: center;
    padding: 5px;
    color: #fff;
    opacity: 0.87;
    text-align: center;
}
</style>
